import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/auth/login/form.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
